import { render } from "./DetalhesProdutoModal.vue?vue&type=template&id=2f450aea&scoped=true&ts=true"
import script from "./DetalhesProdutoModal.vue?vue&type=script&lang=ts"
export * from "./DetalhesProdutoModal.vue?vue&type=script&lang=ts"

import "./DetalhesProdutoModal.vue?vue&type=style&index=0&id=2f450aea&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f450aea"]])

export default __exports__